import HelpText from "../helptext";
import React from "react";
import {formatInputData} from "../steps/bi/tools";

/**
 * Component for rendering a panel header.
 *
 * @param {string} text - The text to display in the panel header.
 * @param {number|number[]} value - The value to display in the panel header.
 *      This will become [0] if the input isn't valid.
 * @param {boolean} [leader=false] - Whether the panel header is a leader.
 * @param {boolean} [fullWidth=false] - Whether the panel header should be full width.
 * @param helpText
 * @param description
 * @param useDollarSign
 * @returns {Element} - The rendered panel list component. */
export const PanelHeader = ({
                                text,
                                value,
                                leader = false,
                                fullWidth = false,
                                helpText = null,
                                description = null,
                                useDollarSign = true
                            }) => {

    const formattedValue = formatInputData(value, useDollarSign);
    const headerClassname = `step-4-panel-header${leader ? ' step-4-panel-header-leader' : ''}`;

    let helpTextItem = null;
    if (helpText) {
        helpTextItem = <HelpText text={helpText}/>;
    }

    let descriptionItem = null;
    if (description) {
        descriptionItem = <span className="description">{description}</span>;
    }

    return (
        <div className={headerClassname}>
            {text}
            <span>{formattedValue}</span>
            {descriptionItem}
            {helpTextItem}
        </div>
    );
};